<mat-nav-list disableRipple>
  <h3 matSubheader>Navigation</h3>
  <a mat-list-item *ngFor="let link of paths" [routerLink]="[link.url]"
    routerLinkActive="active-tab-link"
    #rla="routerLinkActive"
    [routerLinkActiveOptions]="{ exact: true }">
    <span matListItemTitle>{{ link.name }}</span>
    <button mat-icon-button matListItemMeta (click)="openHelper.emit(link.path)">
      <mat-icon>help</mat-icon>
    </button>

  </a>
</mat-nav-list>
